export default __webpack_public_path__ + "static/media/projectx.a2d57f62.png";